(() => {
  const destination = document.currentScript.dataset.whatsappUrl;
  if (!destination) return;

  // Menus and rich text can be supplied by Shopify rather than theme files.
  // Update only explicit WhatsApp destinations, preserving all other attributes.
  function normalize(anchor) {
    const href = anchor.getAttribute('href');
    if (!href) return;
    try {
      const url = new URL(href, document.baseURI);
      const isWhatsApp = url.protocol === 'whatsapp:' ||
        (['https:', 'http:'].includes(url.protocol) &&
          ['wa.me', 'whatsapp.com', 'www.whatsapp.com', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname));
      if (isWhatsApp) {
        if (href !== destination) anchor.setAttribute('href', destination);
        anchor.setAttribute('target', '_blank');
        const rel = new Set((anchor.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
        rel.add('noopener');
        rel.add('noreferrer');
        anchor.setAttribute('rel', [...rel].join(' '));
      }
    } catch {
      // Leave malformed or non-URL contact content unchanged.
    }
  }

  function scan(root) {
    if (root.matches?.('a[href]')) normalize(root);
    root.querySelectorAll?.('a[href]').forEach(normalize);
  }

  scan(document);
  // Covers section rendering, Theme Editor reloads, and dynamically added links.
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') normalize(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
})();
